import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { heatBarChart } from '../MockData';

function HeatChart({width, height}) {
  const options = {
    chart: { type: 'heatmap', height: 450 },
    dataLabels: { enabled: false },
    colors: ['#008FFB'],  // example color
    title: { text: 'Heatmap Chart' }
  };

  return (
    <ReactApexChart
      options={options}
      series={heatBarChart.series}
      type="heatmap"
      height={450}
    />
  );
}

export default HeatChart;
